module.exports = __webpack_public_path__ + "static/img/jiejiari@2x.688a150.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/jiejiari@2x.png
// module id = KdwD
// module chunks = 1